import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Keycloak from "keycloak-js";
import { useAuth } from "./../AuthContext";
import { useTranslation } from "react-i18next";
// database
import data from "../main.json";
// Import SVG icons
import threeBarsIcon from "../media/three-bars.svg";
import logoutButtonIcon from "../media/logout-button.svg";
import LanguageSwitcher from "./LanguageSwitcher";

// const keycloakOptions = {
//   url: 'http://keycloak:8080',  // URL Twojego serwera Keycloak
//   realm: 'test-frontend',       // Nazwa realm
//   clientId: 'react-app-client', // ID klienta
// };

function Header() {
  const { t } = useTranslation();
  // const [keycloak, setKeycloak] = useState(null);
  const [expanded, setExpanded] = useState(null); // Stan rozwiniętej zakładki
  const [subExpanded, setSubExpanded] = useState(null); // Stan rozwiniętej podzakładki
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // Stan menu mobilnego

  const dropdownRef = useRef(null);
  const { logout } = useAuth();
  const { userData } = useAuth();
  const getRole = () => userData.userRole; // Funkcja zwraca rolę użytkownika

  console.log("userRoles", userData.userRoles);
  console.log("getRole", getRole());

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setExpanded(null); // Zamyka wszystkie rozwinięte zakładki
        setSubExpanded(null); // Zamyka wszystkie rozwinięte podzakładki
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // useEffect do zarządzania klasą mobile-menu-open na body
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("mobile-menu-open");
    } else {
      document.body.classList.remove("mobile-menu-open");
    }

    // Cleanup: usuń klasę przy unmount
    return () => {
      document.body.classList.remove("mobile-menu-open");
    };
  }, [isMobileMenuOpen]);

  // const handleLogout = () => {
  //   if (keycloak) {
  //     keycloak.logout();
  //   }
  // };

  const toggleExpand = (section) => {
    setExpanded((prevExpanded) => (prevExpanded === section ? null : section));
  };

  const toggleSubExpand = (section) => {
    setSubExpanded((prevSubExpanded) =>
      prevSubExpanded === section ? null : section,
    );
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-custom">
      <div className="container-fluid">
        <div className="navbar-content" ref={dropdownRef}>
          <div className="mobile-header-left">
            <img
              src={threeBarsIcon}
              alt="Menu"
              onClick={toggleMobileMenu}
              style={{ cursor: "pointer", width: "32px", height: "32px" }}
            />
          </div>

          {/* Mobile header center - Intranet text */}
          <div className="mobile-header-center">{t("header.intranet")}</div>

          {/* Mobile header right side - logout button */}
          <div className="mobile-header-right">
            <img
              src={logoutButtonIcon}
              alt="Logout"
              onClick={logout}
              style={{ cursor: "pointer", width: "32px", height: "32px" }}
            />
          </div>

          <div className={`nav-links ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            <NavLink
              className={`nav-link ${
                expanded === "aktualnosci" ? "active" : ""
              }`}
              to={
                getRole() === "admin" || getRole() === "hr-manager"
                  ? "/administrator/aktualnosci"
                  : "/aktualnosci"
              }
              onClick={() => {
                setExpanded("aktualnosci");
                setSubExpanded(null);
                setIsMobileMenuOpen(false); // Close mobile menu when link is clicked
              }}
            >
              {t("header.announcements")}
            </NavLink>

            {/* Inne zakładki */}
            <div className={`dropdown ${expanded === "hr" ? "expanded" : ""}`}>
              <span
                className={`nav-link ${expanded === "hr" ? "active" : ""}`}
                onClick={() => toggleExpand("hr")}
              >
                {t("header.files")}
              </span>
              {expanded === "hr" && (
                <div className="dropdown-content">
                  <div className="dropdown-submenu">
                    <span
                      className={`nav-link ${
                        subExpanded === "dokumenty" ? "active" : ""
                      }`}
                      onClick={() => toggleSubExpand("dokumenty")}
                    >
                      {t("header.documents")}
                    </span>
                    {subExpanded === "dokumenty" && (
                      <div className="dropdown-content">
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/dokumenty/regulaminy"
                              : "/pliki/dokumenty/regulaminy"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.regulations")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/dokumenty/zarzadzenia"
                              : "/pliki/dokumenty/zarzadzenia"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.directives")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/dokumenty/druki"
                              : "/pliki/dokumenty/druki"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.forms")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/dokumenty/instrukcje"
                              : "/pliki/dokumenty/instrukcje"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.instructions")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/dokumenty/ppk"
                              : "/pliki/dokumenty/ppk"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.ppk")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/dokumenty/ppwr"
                              : "/pliki/dokumenty/ppwr"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.ppwr")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/dokumenty/raporty"
                              : "/pliki/dokumenty/raporty"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.reports")}
                        </NavLink>
                      </div>
                    )}
                  </div>
                  <NavLink
                    className="dropdown-item"
                    to={
                      getRole() === "admin" || getRole() === "hr-manager"
                        ? "/administrator/pliki/ai"
                        : "/pliki/ai"
                    }
                    onClick={() => {
                      setExpanded(null);
                      setSubExpanded(null);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {t("header.ai")}
                  </NavLink>
                  <div className="dropdown-submenu">
                    <span
                      className={`nav-link ${
                        subExpanded === "benefity" ? "active" : ""
                      }`}
                      onClick={() => toggleSubExpand("benefity")}
                    >
                      {t("header.benefits")}
                    </span>
                    {subExpanded === "benefity" && (
                      <div className="dropdown-content">
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/benefity/multisport"
                              : "/pliki/benefity/multisport"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.multisport")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/benefity/opieka-medyczna"
                              : "/pliki/benefity/opieka-medyczna"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.medicalCare")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to={
                            getRole() === "admin" || getRole() === "hr-manager"
                              ? "/administrator/pliki/benefity/ubezpieczenie-grupowe"
                              : "/pliki/benefity/ubezpieczenie-grupowe"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.groupInsurance")}
                        </NavLink>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            <div
              className={`dropdown ${expanded === "baza" ? "expanded" : ""}`}
            >
              <span
                className={`nav-link ${expanded === "baza" ? "active" : ""}`}
                onClick={() => toggleExpand("baza")}
              >
                {t("header.contactDatabase")}
              </span>
              {expanded === "baza" && (
                <div className="dropdown-content">
                  <NavLink
                    className="dropdown-item"
                    to="/baza-teleadresowa/maritex"
                    onClick={() => {
                      setExpanded(null);
                      setSubExpanded(null);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {t("header.maritex")}
                  </NavLink>
                  <NavLink
                    className="dropdown-item"
                    to="/baza-teleadresowa/niviss"
                    onClick={() => {
                      setExpanded(null);
                      setSubExpanded(null);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {t("header.niviss")}
                  </NavLink>
                </div>
              )}
            </div>

            <div
              className={`dropdown ${
                expanded === "nieobecnosci" ? "expanded" : ""
              }`}
            >
              <span
                className={`nav-link ${
                  expanded === "nieobecnosci" ? "active" : ""
                }`}
                onClick={() => toggleExpand("nieobecnosci")}
              >
                {t("header.absences")}
              </span>
              {expanded === "nieobecnosci" && (
                <div className="dropdown-content">
                  <NavLink
                    className="dropdown-item"
                    to="/nieobecnosci/maritex"
                    onClick={() => {
                      setExpanded(null);
                      setSubExpanded(null);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {t("header.maritex")}
                  </NavLink>
                  <NavLink
                    className="dropdown-item"
                    to="/nieobecnosci/niviss"
                    onClick={() => {
                      setExpanded(null);
                      setSubExpanded(null);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {t("header.niviss")}
                  </NavLink>
                </div>
              )}
            </div>

            <div
              className={`dropdown ${
                expanded === "logistyka" ? "expanded" : ""
              }`}
            >
              <span
                className={`nav-link ${
                  expanded === "logistyka" ? "active" : ""
                }`}
                onClick={() => toggleExpand("logistyka")}
              >
                {t("header.logistics")}
              </span>
              {expanded === "logistyka" && (
                <div className="dropdown-content">
                  <NavLink
                    className="dropdown-item"
                    to="/logistyka/uslugi-dhl-parcel"
                    onClick={() => {
                      setExpanded(null);
                      setSubExpanded(null);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {t("header.dhlServices")}
                  </NavLink>
                  <div className="dropdown-submenu">
                    <span
                      className={`nav-link ${
                        subExpanded === "sledzenie" ? "active" : ""
                      }`}
                      onClick={() => toggleSubExpand("sledzenie")}
                    >
                      {t("header.packageTracking")}
                    </span>
                    {subExpanded === "sledzenie" && (
                      <div className="dropdown-content dropdown-content-narrow">
                        <NavLink
                          className="dropdown-item"
                          to="/logistyka/dhl"
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.dhl")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to="/logistyka/ups"
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.ups")}
                        </NavLink>
                        <NavLink
                          className="dropdown-item"
                          to="/logistyka/inpost"
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {t("header.inpost")}
                        </NavLink>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Przeniesiona zakładka Rezerwacje */}
            <div
              className={`dropdown ${
                expanded === "rezerwacje" ? "expanded" : ""
              }`}
            >
              <span
                className={`nav-link ${
                  expanded === "rezerwacje" ? "active" : ""
                }`}
                onClick={() => toggleExpand("rezerwacje")}
              >
                {t("header.reservations")}
              </span>
              {expanded === "rezerwacje" && (
                <div className="dropdown-content">
                  <NavLink
                    className="dropdown-item"
                    to="/rezerwacje/samochody"
                    onClick={() => {
                      setExpanded(null);
                      setSubExpanded(null);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {t("header.cars")}
                  </NavLink>
                  <NavLink
                    className="dropdown-item"
                    to="/rezerwacje/sale-konferencyjne"
                    onClick={() => {
                      setExpanded(null);
                      setSubExpanded(null);
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {t("header.conferenceRooms")}
                  </NavLink>
                </div>
              )}
            </div>

            {/* Harmonogram */}
            {/*
            {(getRole() === "admin" ||
              getRole() === "hr-manager" ||
              (getRole() === "user" &&
                userData.userRoles?.some(
                  (r) => r.toLowerCase() === "student",
                ))) &&
              (() => {
                const isStudent = userData.userRoles?.some(
                  (r) => r.toLowerCase() === "student",
                );

                const isAdmin =
                  !isStudent &&
                  (getRole() === "admin" || getRole() === "hr-manager");

                return (
                  <div
                    className={`dropdown ${
                      expanded === "harmonogram" ? "expanded" : ""
                    }`}
                  >
                    <span
                      className={`nav-link ${
                        expanded === "harmonogram" ? "active" : ""
                      }`}
                      onClick={() => toggleExpand("harmonogram")}
                    >
                      {t("header.schedule")}
                    </span>

                    {expanded === "harmonogram" && (
                      <div className="dropdown-content">
                        <NavLink
                          className="dropdown-item"
                          to={
                            isStudent
                              ? "/harmonogram"
                              : isAdmin
                                ? "/administrator/harmonogram"
                                : "/harmonogram"
                          }
                          onClick={() => {
                            setExpanded(null);
                            setSubExpanded(null);
                            setIsMobileMenuOpen(false);
                          }}
                        >
                          {isStudent
                            ? t("header.mySchedule")
                            : isAdmin
                              ? t("header.viewSchedules")
                              : t("header.mySchedule")}
                        </NavLink>
                      </div>
                    )}
                  </div>
                );
              })()}
            */}

            <LanguageSwitcher />
          </div>
          <button className="btn btn-custom" onClick={logout}>
            {t("common.logout")}
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Header;
